import { createUrl } from "@touchtech/web-api-client";

import { getEnvValue } from "@is/utils/env";

const baseUrl = getEnvValue("VITE_INSTORE_CLOUD_SERVICE_URL");

export const createStockSessionSegmentsUrl = () =>
  createUrl(baseUrl, `api/instore/stock/session-segments`);
